import { useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import { notificationsApi } from '../services/api'

export function dispatchNotificationsChanged() {
  window.dispatchEvent(new CustomEvent('admin-notifications-changed'))
}

export function useMarkNotificationsRead(module, itemId = null) {
  const { hasModuleAccess } = useAuth()

  useEffect(() => {
    if (!module || !hasModuleAccess(module)) return

    notificationsApi
      .markRead(itemId ? { module, item_id: itemId } : { module })
      .then(dispatchNotificationsChanged)
      .catch(() => {})
  }, [module, itemId, hasModuleAccess])
}
